<template>
  <section class="section profile-section-container">
    <div class="profile-header-container">
      <h2 class="header-title">Public Profiles</h2>
      <p>
        Your public profile is a short professional snapshot available to TeamStack customers.
      </p>
      <p>Here are two examples:</p>
    </div>

    <div class="public-profiles-container">
      <ProfileCard
        v-for="profile in profiles"
        :key="profile.name"
        :profile="profile"
        class="public-profile-card"
      />
    </div>

    <div class="profile-footer-container">
      <p>
        Public profiles are designed for anonymity. That way you can join the roster while working
        elsewhere without worrying that your current employer will find out.
      </p>
    </div>
  </section>
</template>

<script setup>
import ProfileCard from "@/components/ProfileCard.vue";

const profiles = [
  {
    name: "Maya",
    title: "Sr BE Engineer, 8y experience",
    experience: "FinTech, Cloud Services",
    skills: "Microservices, API development, database design",
    technologies: "GoLang, NodeJS, PostgreSQL, Kubernetes",
    interests: "Blockchain, AI ethics, yoga",
    languages: "Thai (C2), English (C1)",
    salary: "Salary Level 3",
    availability: "Available in 30 days"
  },
  {
    name: "Lina",
    title: "UX Designer, 3y experience",
    experience: "Mobile banking, E-commerce",
    skills: "UX research, wire framing, prototyping, design systems",
    technologies: "Figma, Adobe XD, Sketch, Notion, Framer",
    interests: "Architecture, fine arts, fashion",
    languages: "Swedish (C2), English (C1), Thai (A2)",
    salary: "Salary Level 2",
    availability: "Available in 30 days"
  }
];
</script>

<style lang="scss" scoped>
.profile-section-container {
  display: flex;
  flex-direction: column;
  gap: 60px;

  .profile-header-container,
  .profile-footer-container {
    margin: 0 auto;
    max-width: 880px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    text-align: center;
    color: #141414;

    p {
      font-weight: 400;
      line-height: 32px;
      text-align: center;
    }
  }

  .profile-header-container p {
    font-size: 24px;
  }

  .profile-footer-container p {
    font-size: 20px;
  }

  .public-profiles-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    gap: 40px;

    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr 1fr;
    }

    .public-profile-card {
      padding: 60px;

      @media screen and (max-width: 768px) {
        padding: 32px 16px;
      }
    }
  }
}
</style>
